import type {MileageValue} from './MileageValue';

export type CommonMileageAttribute = {
  code: 'mileage';
  readonly type?: 'mileage';
  readonly title?: string;
  value: MileageValue | null;
  readonly defaultValue?: MileageValue | null;
  readonly displayValue?: MileageValue | null;
  readonly extra?: any;
  readonly required?: boolean;
  override: boolean;
  readonly hasPublishControl?: boolean;
  publish: boolean;
};
